import React, { useEffect } from 'react';
import { getMenuPath, escapeHtml } from '../utils/bannerUtils';

/**
 * 유형 3 - 타이틀 + 아이콘 + 설명
 * 원본: banner-icon fragment
 *
 * @param {string} title - 페이지 타이틀
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열
 * @param {string} icon - 아이콘 (이모지 또는 텍스트, 기본값: '📋')
 * @param {string} subtitle - 서브타이틀
 */
const BannerIcon = ({ title, breadcrumbPath, icon = '📋', subtitle = '' }) => {
  useEffect(() => {
    // AOS 초기화
    if (typeof window.AOS !== 'undefined') {
      requestAnimationFrame(() => {
        window.AOS.refreshHard();
      });
    }
  }, []);

  const pageTitle = title || '페이지';
  const menuPath = getMenuPath(breadcrumbPath);
  const hasSubtitle = subtitle && subtitle.trim() !== '';
  // 아이콘은 이스케이프하지 않고 그대로 표시 (이모지/아이콘을 위해)
  const iconDisplay = icon || '📋';

  return (
    <>
      <style>
        {`
          .banner-icon {
            background: var(--theme-color-primary);
            padding: 40px 0 40px;
            color: white;
            text-align: center;
            position: relative;
            overflow: hidden;
          }
          .banner-icon::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(circle at 30% 40%, rgba(255,255,255,0.15) 0%, transparent 50%),
                        radial-gradient(circle at 70% 70%, rgba(255,255,255,0.1) 0%, transparent 50%);
            pointer-events: none;
          }
          .banner-icon .container {
            position: relative;
            z-index: 2;
          }
          .banner-icon .banner-icon-wrapper {
            font-size: 5rem;
            margin-bottom: 25px;
            display: inline-block;
            animation: float 3s ease-in-out infinite;
            filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
            line-height: 1;
          }
          @keyframes float {
            0%, 100% { transform: translateY(0px) scale(1); }
            50% { transform: translateY(-15px) scale(1.05); }
          }
          .banner-icon .banner-title {
            font-size: 2.8rem;
            font-weight: 700;
            margin-bottom: 15px;
            text-shadow: 2px 2px 6px rgba(0,0,0,0.3);
            letter-spacing: -0.5px;
          }
          .banner-icon .banner-subtitle {
            font-size: 1.1rem;
            opacity: 0.95;
            margin-bottom: 25px;
            font-weight: 300;
            letter-spacing: 0.5px;
          }
          .banner-icon .banner-breadcrumb {
            font-size: 0.95rem;
            opacity: 0.9;
            display: inline-block;
            padding: 8px 20px;
            background: rgba(255,255,255,0.2);
            backdrop-filter: blur(10px);
            border-radius: 20px;
            border: 1px solid rgba(255,255,255,0.3);
          }
        `}
      </style>
      <div className="banner-icon">
        <div className="container">
          <div className="banner-icon-wrapper">{iconDisplay}</div>
          <h1 className="banner-title" data-aos="fade-down" data-aos-delay="100">
            {escapeHtml(pageTitle)}
          </h1>
          {hasSubtitle && (
            <p className="banner-subtitle">{escapeHtml(subtitle)}</p>
          )}
          <div className="banner-breadcrumb" data-aos="fade-up" data-aos-delay="100">
            {menuPath}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerIcon;

